import {Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ProductNameComponent} from 'src/app/shared/components/product-name/product-name.component';

/**
 * Information explaining the Dine Club offer.  This is displayed in more than one place in the portal, warranting its own component.
 */

@Component({
  selector: 'app-dine-content',
  standalone: true,
  imports: [CommonModule, ProductNameComponent],
  templateUrl: './dine-content.component.html',
  styleUrls: ['./dine-content.component.scss']
})
export class DineContentComponent {

  /**
   * Changes the wording in the header
   */
  showActivated = input<boolean>(false);

  constructor() { }

}
